import { useEffect } from "react";
import axios from "axios";
import { getConsent } from "./CookieBanner";

const API = `${window.__BACKEND__}/api`;
const APP_ID = "e293d01f-494a-4177-95d1-6f99f3443e5d";

function loadOneSignal() {
  if (window.__vdhOneSignalLoaded) return;
  window.__vdhOneSignalLoaded = true;
  const s = document.createElement("script");
  s.src = "https://cdn.onesignal.com/sdks/web/v16/OneSignalSDK.page.js";
  s.defer = true;
  document.head.appendChild(s);
  window.OneSignalDeferred = window.OneSignalDeferred || [];
  window.OneSignalDeferred.push(function (OneSignal) {
    OneSignal.init({
      appId: APP_ID,
      allowLocalhostAsSecureOrigin: true,
      serviceWorkerPath: "OneSignalSDKWorker.js",
    }).then(() => {
      OneSignal.User.PushSubscription.addEventListener("change", async (event) => {
        if (event.current?.id) {
          try {
            await axios.post(`${API}/push/subscribe`, {
              subscription_id: event.current.id,
              opted_in: !!event.current.optedIn,
            });
          } catch (e) {
            /* ignore */
          }
        }
      });
    });
  });
}

/**
 * Loads OneSignal SDK silently (no in-page banner).
 * The "Attiva notifiche" CTA lives on /pwa-test for explicit opt-in.
 */
export default function OneSignalInit() {
  useEffect(() => {
    const consent = getConsent();
    if (!consent?.marketing) {
      const onConsent = (e) => {
        if (e.detail?.marketing) loadOneSignal();
      };
      window.addEventListener("vdh-consent-changed", onConsent);
      return () => window.removeEventListener("vdh-consent-changed", onConsent);
    }
    loadOneSignal();
  }, []);

  return null;
}
